import { useAppContext } from 'app/AppContext'
import React from 'react'
import useAuth from 'useAuth'
import RoutesMenusPrivate from './private'
import RoutesMenusPublic from './public'


export default function RoutesMenus() {
     // eslint-disable-next-line no-unused-vars
     const { userAux } = useAppContext()//RELOAD USER
     const { isAuthenticated } = useAuth()
     const isAuthenticatedV = isAuthenticated()
 
     // console.log('RoutesMenus Private?:', isAuthenticatedV)
     if (isAuthenticatedV) {
         return (
             <>
                 <RoutesMenusPrivate />
             </>
         )
     } else {
         return (
             <>
 
                 <RoutesMenusPublic />
             </>
 
         )
     }
}
